import { render, staticRenderFns } from "./App.vue?vue&type=template&id=10d38351&scoped=true&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&id=10d38351&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../NodeModules/Ljbc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d38351",
  null
  
)

export default component.exports